import * as React from 'react';
import { view } from '@sail/ui';
import { createViewConfig } from '@sail/engine';
export const BasicIconConfig = createViewConfig({
    props: {},
    name: 'BasicIcon'
});
/**
 * Simple filled UI icon glpyhs
 */ export const BasicIcon = BasicIconConfig.createView(({ icon, ...rest })=>{
    switch(icon){
        case 'compassArrow':
            return /*#__PURE__*/ React.createElement(view.svg, {
                width: "11",
                height: "11",
                viewBox: "0 0 11 11",
                xmlns: "http://www.w3.org/2000/svg",
                ...rest
            }, /*#__PURE__*/ React.createElement("title", null, "Compass arrow icon"), /*#__PURE__*/ React.createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0.537156 6.04305H4.95716V10.472C4.95716 11.039 5.72016 11.2191 5.97316 10.7121L10.9302 0.780051C11.1612 0.318051 10.6722 -0.17195 10.2102 0.0590505L0.297156 5.02505C-0.208844 5.27905 -0.0288441 6.04305 0.537156 6.04305Z",
                fill: "currentColor"
            }));
        case 'circleCheck':
            return /*#__PURE__*/ React.createElement(view.svg, {
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                xmlns: "http://www.w3.org/2000/svg",
                ...rest
            }, /*#__PURE__*/ React.createElement("title", null, "Circle check icon"), /*#__PURE__*/ React.createElement(view.path, {
                d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm3.41 4.93L6.64 9.54 5.38 8.18a.7.7 0 0 0-.87-.04.61.61 0 0 0-.18.8l1.5 2.45c.15.22.41.36.69.36.28 0 .53-.14.68-.36.24-.31 4.82-5.78 4.82-5.78.6-.6-.13-1.15-.6-.68z",
                fillRule: "evenodd",
                fill: "currentColor"
            }));
        default:
            return null;
    }
});

//# sourceMappingURL=BasicIcon.js.map